import { Component } from '@angular/core';

@Component({
  selector: 'app-before-login',
  standalone: true,
  imports: [],
  templateUrl: './before-login.component.html'
})
export class BeforeLoginComponent {}
